import { useMemo } from "react";
import { Product } from "~/stores/checkout/product";
import { useCheckoutStore } from "~/stores/checkout/useCheckoutStore";

const useCosmeticProducts = () => {
  const [selectedProducts, setSelectedProducts] = useCheckoutStore((state) => [
    state.selectedProducts,
    state.setSelectedProducts,
  ]);

  const hasCosmeticProducts = useMemo(() => {
    return selectedProducts.find((product) => product.family === "cosmetic");
  }, [selectedProducts]);

  const toggleCosmeticProduct = (product: Product) => {
    const list = [...selectedProducts];
    const index = list.findIndex((selected) => selected.id === product.id);

    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(product);
    }

    setSelectedProducts(list);
  };

  const isCosmeticProductSelected = (productId: string) => {
    return selectedProducts.some((product) => product.id === productId);
  };

  return {
    toggleCosmeticProduct,
    isCosmeticProductSelected,
    selectedProducts,
    hasCosmeticProducts,
  };
};

export default useCosmeticProducts;
